module.exports = __webpack_public_path__ + "img/7.2da5ffb7.jpg";